import * as React from "react";
import Button from "../../buttons/Button";

import "./ErrorPage.scss";

/**
 * ErrorPage component
 * @module
 */
const ErrorPage = (props) => {
  const handleReload = () => {
    window.location.reload();
  };
  const handleHome = () => {
    window.location.href = window.location.origin + window.location.pathname;
  };

  return (
    <div className="error">
      <h1>Ups...niečo sa pokazilo!</h1>
      <div>Ospravedlňujeme sa za to, kontaktujte prosím správcu.</div>
      <div className="errorButtons">
        <Button primary label="Znova načítať stránku" onClick={handleReload} />
        <Button label="Domov" onClick={handleHome} />
      </div>
      <div className="errorDev">
        <div>{props.error?.message}</div>
      </div>
    </div>

  );
}

export default ErrorPage;